import { useAppTranslation } from "@/utils";
import { Button, Card, Flex, Form, Input, Typography } from "@payping/web-components";
import { FC, useEffect, useState } from "react";
import { PlanData } from ".";

export interface formInputs {
  minPrePaymentRate: number;
}
type Props = {
  onNext: (value: number) => void;
  onPrev: () => void;
  planData: PlanData;
};
const PreInstallmentAmount: FC<Props> = ({ onNext, onPrev, planData }) => {
  const { t } = useAppTranslation();
  const [form] = Form.useForm<formInputs>();
  const [isFormValid, setIsFormValid] = useState(false);
  useEffect(() => {
    if (planData?.minPrePaymentRate != null) {
      form.setFieldValue("minPrePaymentRate", planData.minPrePaymentRate);
      form.validateFields();
    }
  }, [planData, form]);
  return (
    <Form<formInputs>
      form={form}
      layout="vertical"
      className="tw-w-full"
      onFieldsChange={() => {
        const hasErrors = form.getFieldsError().some((field) => field.errors.length > 0);
        setIsFormValid(!hasErrors);
      }}
      onFinish={() => {
        const { minPrePaymentRate } = form.getFieldsValue();
        onNext(minPrePaymentRate);
      }}
    >
      <Flex vertical gap={"large"} className="tw-w-full tw-max-w-[545px] max-md:tw-max-w-[100%]">
        <Flex vertical gap={"small"}>
          <Typography.Title level={5} className="!tw-m-0">
            {t("shop.bnpl.addInstallmentPlan.steps.PreInstallmentAmount.form.precent.title")}
          </Typography.Title>
          <Typography.Text className="!tw-m-0">
            {t("shop.bnpl.addInstallmentPlan.steps.PreInstallmentAmount.form.precent.description")}
          </Typography.Text>
          <Card.Ant className="tw-mt-1 tw-w-full">
            <Form.Item
              name={"minPrePaymentRate"}
              label={t("shop.bnpl.addInstallmentPlan.steps.PreInstallmentAmount.form.precent.label")}
              rules={[
                { required: true },
                {
                  validator(_, value) {
                    if (value < 0) {
                      return Promise.reject(
                        new Error(
                          t("common.validations.min", {
                            name: t("shop.bnpl.addInstallmentPlan.steps.PreInstallmentAmount.form.precent.label"),
                            min: "0",
                          }),
                        ),
                      );
                    }
                    if (value > 99) {
                      return Promise.reject(
                        new Error(
                          t("common.validations.max", {
                            name: t("shop.bnpl.addInstallmentPlan.steps.PreInstallmentAmount.form.precent.label"),
                            max: "100",
                          }),
                        ),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input.Number
                className="tw-w-full tw-text-center"
                style={{ textAlignLast: "center" }}
                inputMode="numeric"
                changeOnWheel={false}
                controls={false}
                separateThousandth
                step={1000}
                addonAfter={"%"}
              />
            </Form.Item>
          </Card.Ant>
        </Flex>
        <Flex gap={"small"}>
          <Button block={false} onClick={onPrev} className="!tw-px-8" loading={false} type="default">
            {t("common.previousStep")}
          </Button>
          <Button
            block={false}
            disabled={!isFormValid}
            onClick={form.submit}
            className="!tw-px-8"
            loading={false}
            type="primary"
          >
            {t("common.saveAndContinue")}
          </Button>
        </Flex>
      </Flex>
    </Form>
  );
};

export default PreInstallmentAmount;
